/* DON'T EDIT THIS FILE: edit original and run build again */ export enum TokenError {
  notFound = "matchfin/token-not-found",
  expired = "matchfin/token-expired",
  unsupported = "matchfin/token-unsupported",
  noActiveToken = "matchfin/no-active-token",
}
